import React from 'react';

import InputLabel from '@mui/material/InputLabel';
import CheckCircle from '@mui/icons-material/CheckCircle';

import { Box } from '@vk-hr-tek/ui/Box';
import { Typography } from '@vk-hr-tek/ui/Typography';

import useStyles from './FormKnownValue.styles';

interface FormKnownValueProps {
  label: string;
  value?: string | null;
  verified?: boolean;
  caption?: string | null;
}

/**
 * Компонент для отображения имени поля формы и его значения с возможной меткой верификации и подписью.
 * @param {string} label - Текст метки для поля формы.
 * @param {string | null} [value] - Значение поля формы. Может быть строкой или null.
 * @param {boolean} [verified=true] - Флаг, указывающий, верифицировано ли значение.
 * @param {string | null} [caption] - Подпись для поля формы, которая может отображаться под значением.
 */

export const FormKnownValue = ({
  label,
  value,
  verified = true,
  caption,
}: FormKnownValueProps) => {
  const { classes } = useStyles();

  return (
    <Box>
      <InputLabel className={classes.label}>{label}</InputLabel>
      <Box display="flex" justifyContent="start" alignItems="center">
        <Typography variant="body2">{value || ''}</Typography>

        {verified && (
          <Box ml="8" display="flex" alignItems="center">
            <CheckCircle fontSize="small" color="primary" />
          </Box>
        )}
      </Box>
      {caption && <span className={classes.caption}>{caption}</span>}
    </Box>
  );
};
